import GenericTable from './generic-table';

export default GenericTable;